import React, { useState } from 'react';
import { PayPalButtons } from '@paypal/react-paypal-js';
import { useDispatch } from 'react-redux';
import { paymentActions } from '../store/payment.slice';
import { onboardingActions } from '../store/onboarding.slice';
import { toast } from 'react-toastify';
import HttpStatus from '../helpers/status.enum';
import SpinnerLoader from './SpinnerLoader';

const PayPalCheckoutForm = ({
  paypalOrderId,
  paymentSlug,
  bookingSlug,
  intentType,
  onSuccess,
  onCancel,
}) => {
  const dispatch = useDispatch();
  const [processing, setProcessing] = useState(false);

  if (!paypalOrderId) return null;

  const handleApprove = async () => {
    setProcessing(true);
    try {
      // Mirrors CheckoutForm.js's (Stripe) sequence: onboarding must run first — it's
      // the only write that sets waiver_checkin, without which WaiverRefund's lookup
      // (requires it NOT NULL) can never find the transaction.
      const onboardingFormData = {
        booking_slug: bookingSlug,
        is_house_rules_accepted: 0,
        is_signed_on_dotted_line: 0,
        is_verification_ids_uploaded: 0,
        is_deposit_option: 1,
        deposit_option: intentType,
        card_token: paypalOrderId,
        is_arrival_info_accepted: 0,
        form_submission_at: 0,
      };
      const onboardingResult = await dispatch(
        onboardingActions.submitOnboardingSteps(onboardingFormData)
      );
      if (onboardingResult?.payload?.status !== HttpStatus.HTTP_OK) {
        toast(onboardingResult?.payload?.message || 'Something went wrong. Please try again.');
        return;
      }

      const result = await dispatch(
        paymentActions.updatePaymentStatus({
          booking_slug: bookingSlug,
          payment_slug: paymentSlug,
        })
      );
      const response = result?.payload;
      if (response?.status === HttpStatus.HTTP_OK) {
        onSuccess?.();
      } else {
        toast(response?.message || 'Payment failed. Please try again.');
      }
    } catch (error) {
      toast('Something went wrong. Please try again.');
    } finally {
      setProcessing(false);
    }
  };

  return (
    <>
      {processing && <SpinnerLoader />}
      <PayPalButtons
        // Order was pre-created server-side; return the existing ID rather than
        // calling create-payment-intent again — doing so would create a duplicate order.
        createOrder={() => paypalOrderId}
        onApprove={handleApprove}
        onError={() => toast('PayPal payment failed. Please try again.')}
        onCancel={onCancel}
        style={{ layout: 'vertical', shape: 'rect' }}
        disabled={processing}
      />
    </>
  );
};

export default PayPalCheckoutForm;
